import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppService } from './app.service';

// 扫码自动登录使用的共享账户，userId 固定为 -1
const SCAN_LOGIN_USER_ID = '-1';
// 该账户只允许停留在对应扫码入口落地的模块下（含各自子页面，如 finding-detail/form）
// 对应 login/auto-issue-reporting、login/auto-immediate-inspection、login/auto-immediate-observation 三个扫码入口
const SCAN_LOGIN_ALLOWED_PATH_PREFIXES = [
  '/inspection/ehs-inspection/issue-reporting',
  '/inspection/ehs-inspection/immediate-inspection',
  '/inspection/bbso/immediate-observation',
];

@Injectable({
  providedIn: 'root'
})
export class CanActiveGuardService implements CanActivate {
  constructor(private appService: AppService) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userId = window.localStorage.getItem('userId');
    const isAllowedPath = SCAN_LOGIN_ALLOWED_PATH_PREFIXES.some(prefix => state.url.indexOf(prefix) === 0);
    if (userId === SCAN_LOGIN_USER_ID && !isAllowedPath) {
      this.appService.logout();
      return false;
    }
    return true;
  }
}
